import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { SALES ,SALESSERV, USEORLINE} from './endpoints';

@Injectable({
  providedIn: 'root'
})
export class SalesService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
}

getItems(assignmentParams: any): Observable<any> {
  const url = SALES + '?' + this.makeQueryString(assignmentParams);
  return this.getRequest(url, null);
}
getSalesById(id: number): Observable<any> {
  const url = SALES + '/' + id;
  return this.getRequest(url, null);
}
update(Id: number, updateParams: any): Observable<any> {
  const url = Id?SALES + '/' + Id:SALES;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.putRequest(url, updateParams, options);
}
approval(id: number, updateParams: any): Observable<any> {
  const url = SALES + '/' + id;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.putRequest(url, updateParams, options);
}
delete(id: number): Observable<any> {
  const url = SALES + '/' + id;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.deleteRequest(url, options);
}
getSalesItems(assignmentParams: any): Observable<any> {
  const url = SALESSERV + '?' + this.makeQueryString(assignmentParams);
  return this.getRequest(url, null);
}
updateSalesQoute(Id: number, updateParams: any): Observable<any> {
  const url = Id?SALES + '/' + Id:SALES;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.postRequest(url, updateParams, options);
}
UsEorQuoteLineItems(Id: number, updateParams: any): Observable<any> {
  const url = USEORLINE + '?quote_id=' + Id;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.postRequest(url, updateParams, options);
}
getUsEorQuoteLineItemsById(id: number): Observable<any> {
  const url = USEORLINE + '/' + id;
  return this.getRequest(url, null);
}
deleteUsEorQuoteLineItemsById(id: number): Observable<any> {
  const url = USEORLINE + '/' + id;
  const options = {
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*'
      }
  };
  return this.deleteRequest(url, options);
}

}
